import React from "react";
import { 
  Cpu, 
  Activity, 
  Zap, 
  Wifi, 
  ShieldCheck, 
  Database,
  Thermometer,
  Layers
} from "lucide-react";
import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./Specs.css";

const Specs = () => {
  const hardwareRegistry = [
    {
      title: "MAX30102",
      id: "HR_SPO2_NODE",
      icon: <Activity size={24} />,
      specs: [
        { label: "Modality", value: "Photoplethysmogram" },
        { label: "Resolution", value: "18-bit ADC" },
        { label: "Sync Rate", value: "50-3200 sps" },
        { label: "Current", value: "1.2mA (Active)" }
      ]
    },
    {
      title: "AD8232",
      id: "ECG_WAVEFORM_HUB",
      icon: <Layers size={24} />,
      specs: [
        { label: "Lead Mapping", value: "Single Lead (Lead I)" },
        { label: "Sync Interface", value: "Analog Front End" },
        { label: "Filter Node", value: "High-Pass (0.5Hz)" },
        { label: "CMRR", value: "80dB" }
      ]
    },
    {
      title: "DS18B20",
      id: "TEMP_OVERSIGHT",
      icon: <Thermometer size={24} />,
      specs: [
        { label: "Interface", value: "1-Wire Serial" },
        { label: "Range", value: "-55°C to +125°C" },
        { label: "Accuracy", value: "±0.5°C" },
        { label: "Resolution", value: "12-bit" }
      ]
    },
    {
      title: "Sovereign Relay",
      id: "COMPUTE_BRIDGE",
      icon: <Cpu size={24} />,
      specs: [
        { label: "Core Node", value: "Dual Core Tensilica" },
        { label: "Clock", value: "240MHz" },
        { label: "Connectivity", value: "WiFi 4 / BLE 4.2" },
        { label: "Security", value: "Hardware AES/SHA" }
      ]
    }
  ];

  return (
    <div className="specs-portal">
      <Navigation />
      
      {/* Tactical Overlays */}
      <div className="specs-grid-overlay"></div>
      <div className="specs-scanline"></div>

      <main className="specs-content">
        <header className="specs-hero">
          <div className="specs-hud-badge">
            <ShieldCheck size={14} />
            <span>SYSTEM_SPECIFICATIONS_V1.8.2</span>
          </div>
          <h1>Technical <span className="text-gradient">Node Specs</span></h1>
          <p>The Medico.in hardware ecosystem is synchronized with medical-grade IoT protocols to deliver sub-second clinical telemetry across the sovereign health network.</p>
        </header>

        <section className="specs-registry">
          {hardwareRegistry.map((node, index) => (
            <div key={index} className="specs-card">
              <div className="specs-card-header">
                <div className="specs-card-icon">{node.icon}</div>
                <div className="specs-card-title">
                  <h3>{node.title}</h3>
                  <span>{node.id}</span>
                </div>
              </div>
              <div className="specs-detail-list">
                {node.specs.map((item, sIndex) => (
                  <div key={sIndex} className="specs-item">
                    <span className="specs-label">{item.label}</span>
                    <span className="specs-value">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>

        <section className="specs-latency-node">
          <div className="latency-meta">
            <div className="specs-hud-badge">
              <Wifi size={14} />
              <span>NETWORK_LATENCY_AUDIT</span>
            </div>
            <h2>Global Sync <span className="text-gradient">Targets</span></h2>
            <p>Our distributed database nodes are optimized for industrial clinical responsiveness across all identity streams.</p>
          </div>
          
          <div className="latency-stats">
            <div className="stat-box">
              <span className="stat-value">180ms</span>
              <span className="stat-label">End-to-End Latency</span>
            </div>
            <div className="stat-box">
              <span className="stat-value">99.9%</span>
              <span className="stat-label">Uptime Protocol</span>
            </div>
            <div className="stat-box">
              <span className="stat-value">256-bit</span>
              <span className="stat-label">Node Encryption</span>
            </div>
          </div>
        </section>
      </main>

      <FooterSection />
    </div>
  );
};

export default Specs;
